import { config } from "../AppConfig";

async function createPaymentIntent() {
  const result = await fetch(`${config.url.API_BASE}/api/ajax/v1/stripe/payment/intent`, {
    method: "GET",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  });

  return {
    status: result.status,
    data: await result.json(),
  };
}

async function checkout(paymentMethod, billingDetails, userId, purchaseLinkId, referralUser, discount_code) {
  const result = await fetch(`${config.url.API_BASE}/api/ajax/v1/stripe/checkout`, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({
      user_id: userId,
      discount_code: discount_code,
      purchase_link_id: purchaseLinkId,
      payment_method: paymentMethod,
      billing_details: billingDetails,
      referral_user_id: referralUser
    })
  });

  const json = await result.json();
  console.log(result.status);
  if (result.status === 402){
    //402 = Stripe payment error
    return {data:null, error: json}
  } else if (result.status === 200){
    //200 = ok
    return {data: json, error: null};
  } else if (result.status === 400) {
    console.log(json.details);
    return { data: null, error: json.details}
  }
}


async function resubscribe(paymentMethod, billingDetails, userId) {
  const result = await fetch(`${config.url.API_BASE}/api/ajax/v1/stripe/subscribe`, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({
      user_id: userId,
      payment_method: paymentMethod,
      billing_details: billingDetails
    })
  });

  const json = await result.json();

  if (result.status === 402){
    //402 = Stripe payment error
    return {data:null, error: json}
  } else if (result.status === 200){
    //200 = ok
    return {data: json, error: null};
  }
}

async function validatePromoCode(code) {
  const result = await fetch(`${config.url.API_BASE}/api/ajax/v1/stripe/promo?code=${code}`, {
    method: "GET",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include"
  });

  const json = await result.json();
  return json;
}


export const stripeService = {
  createPaymentIntent,
  checkout,
  resubscribe,
  validatePromoCode
};
